module.exports = __webpack_public_path__ + "img/ring_g_s_1_1@2x.2088e84d.png";